import {
  IADatabase,
  IADatabaseCreateCommentDocument,
  IADatabaseSendEmailDocument,
  IDBSearchAndFilters,
} from "../types/admissionDatabase";
import { ITableResponse } from "../types/applicationOnline";
import { apiType } from "./apiType";

export const admissionDatabaseRequests = {
  /** GET /auth?fullname=... — documents for a student from Admissions Office DB. */
  getAuthDocsByFullname: async (fullname: string) => {
    try {
      return await apiType.admissionDB.get<unknown>("/auth", { fullname });
    } catch (error) {
      console.log("Это ошибка getAuthDocsByFullname:", error);
      return null;
    }
  },

  getListAdmin: async (currentPage: string) => {
    try {
      return await apiType.admissionDB.get<ITableResponse>(`/get/all&page=${currentPage}`);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  getListDefault: async (currentPage: string) => {
    try {
      return await apiType.admissionDB.get<IADatabase>(`/get/documents?page=${currentPage}`);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  getListCustom1: async (currentPage: string) => {
    try {
      return await apiType.admissionDB.get<ITableResponse>(
        `/get/certificate-ls&page=${currentPage}`
      );
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  filterAndSearch: async (data: IDBSearchAndFilters) => {
    try {
      return await apiType.admissionDB.post<IADatabase>(`/filter-and-search`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteCurrentDocument: async (id: number, userOffice: string) => {
    try {
      return await apiType.admissionDB.delete(`/delete?document_id=${id}&userOffice=${userOffice}`);
    } catch (error) {
      console.log("Это ошибка deleteCurrentDocument:", error);
      return null;
    }
  },
  updateDocumentAvailability: async (documentId: number, isAvailable: boolean) => {
    try {
      console.log("[AOD] update availability request", {
        method: "PUT",
        url: `/documents/${documentId}/availability`,
        body: { is_avaliable: isAvailable },
      });
      return await apiType.admissionDB.put(`/documents/${documentId}/availability`, { is_avaliable: isAvailable });
    } catch (error) {
      console.log("Это ошибка updateDocumentAvailability:", error);
      return null;
    }
  },
  sendEmailCurrentDocument: async (data: IADatabaseSendEmailDocument) => {
    try {
      // post<IADatabase>
      return await apiType.admissionDB.post(`/send-doc`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteCommentCurrentDocument: async (data: { comment_id: number }) => {
    try {
      return await apiType.admissionDB.delete(`/comments/delete`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteAllCommentsCurrentDocument: async (data: { document_id: number }) => {
    try {
      return await apiType.admissionDB.delete(`/comments/delete-all`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  createCommentCurrentDocument: async (data: IADatabaseCreateCommentDocument) => {
    try {
      return await apiType.admissionDB.post(`/comments/create`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
};
